<template>
  <section class="step3-form" :style="{minHeight:(screenHeight-85)+'px'}">
    <div v-if="this.$route.query.yanse == 1"  class="step-form__step-num2" >2/5</div>
    <div v-if="this.$route.query.yanse == 2" class="step-form__step-num" >2/5</div>
    <div class="step-form__main">
      <h1 class="step-form__title">{{this.$route.query.productName}}-{{stepsTitle}}</h1>
      <div v-if="!isaddBank">
      <div class="bankcard-list-container" v-show="showList">
        <ul class="bankcard-list">
          <li :key="item.bankAccountId" :class="['bankcard-list__list-item', item.selected ? 'is-selected' : '']"
              v-for="item in bankcardList_bl.bankList" @click="selectBankcard(item)">
            <div class="bankcard-list__list-item__btn-container">
              <span @click.stop="checkForm(item)">查看</span>
            </div>
            <span class="bankcard-list__list——custom" v-show="item.isReturnAcount && item.isPayAcount">回款专户</span>
            <span class="bankcard-list__list——jscustom" v-show="item.isReturnAcount && item.isPayAcount">结算账户</span>
            <span class="bankcard-list__list——jscustom-single" v-show="item.isReturnAcount && !item.isPayAcount">回款专户</span>
            <span class="bankcard-list__list——jscustom-single" v-show="!item.isReturnAcount && item.isPayAcount">结算账户</span>
            <h5 class="bankcard-list__list-item__bank-name">{{item.bankName}}</h5>
            <h6 class="bankcard-list__list-item__branch-bank-name">{{item.bankBranchName}}</h6>
            <div class="bankcard-list__list-item__bankcard-num">{{item.bankAccountName | replaceBankcardNumWithStar}}
            </div>
          </li>
          <li class="bankcard-list__add" @click="newForm">
            <i class="el-icon-plus"></i>
          </li>
        </ul>
      </div>
      <div class="bankcard-form-container" v-show="!showList">
        <el-row :gutter="0" class="step-form__form">
          <el-col :span="16">
            <el-form :label-width="'50%'" :model="bankcardForm" ref="bankcardForm">
              <el-form-item label="开户名称">
                <el-input type="text" v-model="bankcardForm.bankUserName" :disabled="true"
                          placeholder="请输入开户名称"></el-input>
              </el-form-item>
              <el-form-item label="银行所属区域">
                <el-cascader :options="regionData" :props="bankRegionProps" :disabled="true"
                             v-model="bankcardForm.bankRegion" v-if="regionData"
                             placeholder="请选择银行所属区域"></el-cascader>
              </el-form-item>
              <el-form-item label="开户银行">
                <el-select v-model="bankcardForm.bankName" filterable remote :remote-method="searchBankName"
                           :disabled="true" placeholder="请输入开户银行">
                  <el-option v-for="item in bankNameData" :key="item.value" :label="item.text"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="支行名称">
                <el-input type="text" v-model="bankcardForm.bankBranchName" :disabled="true"
                          placeholder="请输入支行名称"></el-input>
              </el-form-item>
              <el-form-item label="开户行行号" prop="bankSwift">
                <el-input type="text" v-model="bankcardForm.bankSwift" :disabled="true"
                          placeholder="请输入开户行行号" :maxlength="35"></el-input>
              </el-form-item>              
              <el-form-item label="开户账户">
                <el-input type="text" v-model="bankcardForm.bankAccountName" :disabled="true"
                          placeholder="请输入开户账户"></el-input>
              </el-form-item>
              <el-form-item label="账户类型" prop="bankUseTypeArr">
                  <el-checkbox-group v-model="bankcardForm.bankUseTypeArr">
                    <el-checkbox label="0" :disabled="true">回款专户</el-checkbox>
                    <el-checkbox label="1" :disabled="true">结算账户</el-checkbox>
                  </el-checkbox-group>
              </el-form-item>              
            </el-form>
          </el-col>
        </el-row>
      </div>
      <div class="step-form__btn-container" v-if="showList">
        <button v-if="this.$route.query.yanse == 1" class="step-form__btn-prev2"  @click="goBack">上一步</button>
        <button v-if="this.$route.query.yanse == 1" class="step-form__btn-next2"  @click="goNext" element-loading-text="Loading">下一步</button>
        <button v-if="this.$route.query.yanse == 2" class="step-form__btn-prev"  @click="goBack">上一步</button>
        <button v-if="this.$route.query.yanse == 2" class="step-form__btn-next"  @click="goNext" element-loading-text="Loading">下一步</button>
      </div>
      <div class="step-form__btn-container" v-else>
        <button class="step-form__btn-next" @click="closeCard()">取消</button>
      </div>
      </div>
      <div class="addBank" v-if="isaddBank">
        <div class="bankcard-form-container">
          <el-row :gutter="0" class="personal-center-form__form">
            <el-col :span="16">
              <el-form :label-width="'50%'" :model="bankcardForm" :rules="rules" ref="bankcardForm" style="margin-left: -180px;">
                <el-form-item label="开户名称">
                  <el-input type="text" v-model="bankcardForm.bankUserName" :disabled="!isaddBank"
                            placeholder="请输入开户名称" :maxlength="35"></el-input>
                </el-form-item>
                <el-form-item label="银行所属区域" prop="bankRegion">
                  <el-cascader :options="regionData" :props="bankRegionProps" :disabled="!isaddBank"
                               @active-item-change="changeRegionData"
                               v-model="bankcardForm.bankRegion" v-if="regionData"
                               placeholder="请选择银行所属区域"></el-cascader>
                </el-form-item>
                <el-form-item label="开户银行" prop="bankName">
                <el-select v-model="bankcardForm.bankName" filterable remote :remote-method="searchBankName"
                :disabled="!isaddBank" @change="changeBankName" placeholder="请输入关键字选择开户银行,如“顺德农商”"
                @focus="showBankCardTips()">
                <el-option v-for="item in bankNameData" :key="item.value" :label="item.text"
                :value="item.value"></el-option>
                </el-select>
                </el-form-item>
                <el-form-item label="开户行行号" prop="bankSwift">
                  <el-input type="text" v-model="bankcardForm.bankSwift" :disabled="!isaddBank"
                            placeholder="请输入开户行行号" :maxlength="35"></el-input>
                </el-form-item>                
                <el-form-item label="支行名称" prop="bankBranchName">
                  <el-input type="text" v-model="bankcardForm.bankBranchName" :disabled="!isaddBank"
                            placeholder="请输入支行名称" :maxlength="35"></el-input>
                </el-form-item>
                <el-form-item label="开户账户" prop="bankAccountName">
                  <div class="showFormatBankAccountName" v-if="isShowFormatBANBox">
                    <span>{{bankAccountNameSpace}}</span>
                  </div>
                  <el-input type="text" v-model="bankcardForm.bankAccountName" :disabled="!isaddBank"
                            @input="addBankcardNumSpaces" @focus="showFormatBANBox" :maxlength="23"
                            placeholder="请输入开户账户"></el-input>
                </el-form-item>
                <el-form-item label="账户类型" prop="bankUseTypeArr">
                    <el-checkbox-group v-model="bankcardForm.bankUseTypeArr">
                      <el-checkbox label="0" :disabled="!isaddBank">回款专户</el-checkbox>
                      <el-checkbox label="1" :disabled="!isaddBank">结算账户</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>                
                <!-- <div v-if="isaddBank">
	                <el-form-item prop="hasReadContract" class="protocol_cont text-center bankContract">
	                  <el-checkbox-group v-model="bankcardForm.hasReadContract">
	                    <el-checkbox class="step1__has-read-loan-contract" label="我已阅读并同意"></el-checkbox>
	                  </el-checkbox-group>
	                  <a class="step1__show-loan-contract step1__show-loan-contract3" @click.prev="showBankContract">《绑定协议》</a>
	                </el-form-item>
                </div> -->
              </el-form>
            </el-col>
          </el-row>
        </div>
        <div class="text-center">
          <el-button type="primary" v-if="isaddBank" style="background:#EB662B;" :loading="isSubmitting" class="personal-center-form__submit"
                     @click="saveBankcard">
            确定
          </el-button>
          <el-button type="primary" style="background:#EB662B;" class="personal-center-form__submit" @click="hideForm">
            返回
          </el-button>
        </div>
      </div>
    </div>
    <el-dialog class="success-modal" top="23%" :visible="gylSuccessModal.show" :before-close="beforeCloseGylSuccessModal"
               :close-on-click-modal="false" @close="closeGylSuccessModal">
      <div class="success-modal__text">{{gylSuccessModal.content}}</div>
    </el-dialog>    
  </section>
</template>
<script>
import _ from 'lodash';
import placeholders from '../../scripts/placeholders';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import * as types from '../../vuex/types';
import api from '../../vuex/api';
import applyloanApi from '../../api/applyloan'; // 引入API

export default {
  data () {
    return {
      gylSuccessModal:{
        show:false,
        content:''
      },
      isaddBank: false,
      fullscreenLoading: false,
      selectedBankcard2: [],
      stepsTitle: '银行账户信息确认',
      bankcardList_bl2: {},
      bankcardList_bl: {
        bankList: []
      },
      showList: true,
      isSubmitting: false,
      selectedBankcardId: '',
      screenHeight: document.body.clientHeight,
      bankRegionProps: {
        value: 'code',
        label: 'name',
        children: 'children'
      },
      rules: {
        bankType: [
          {
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (value.trim() === '') {
                callback(new Error('请选择账户种类'));
              } else {
                callback();
              }
            }
          }
        ],
        bankRegion: [
          {
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (value.length === 0) {
                callback(new Error('请选择银行所属区域'));
              } else {
                callback();
              }
            }
          }
        ],
        bankName: [
          {
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (value.trim() === '') {
                callback(new Error('请输入开户银行'));
              } else {
                callback();
              }
            }
          }
        ],
        bankBranchName: [
          {
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (value.trim() === '') {
                callback(new Error('请输入支行名称'));
              } else {
                callback();
              }
            }
          }
        ],
        bankUseTypeArr:[{
          trigger: 'change',
          validator: (rules, value, callback) => {
            if (value.length === 0) {
              callback(new Error('请勾选账户类型'));
            } else {
              callback();
            }
          }
        }],
        bankSwift: [{
          trigger: 'blur',
          validator: (rules, value, callback) => {
            if (value.trim() === '') {
              callback(new Error('请输入开户行行号'));
            } else {
              callback();
            }
          }
        }],                
        bankAccountName: [
          {
            trigger: 'blur',
            validator: (rules, value, callback) => {
              value = value.replace(/\s/g, '');
              this.isShowFormatBANBox = false;
              if (value.trim() === '') {
                callback(new Error('请输入开户账户'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('请输入正确的银行卡账户号码'));
              } else if (value.length < 12) {
                callback(new Error('银行卡账户号码不能小于12位'));
              } else if (value.length > 30) {
                callback(new Error('银行卡账户号码不能大于30位'));
              } else {
                callback();
              }
            }
          }
        ],
        hasReadContract: [
          {
            trigger: 'change',
            validator: (rules, value, callback) => {
              if (!value) {
                callback(new Error('必须阅读并同意《贷款协议》'));
              } else {
                callback();
              }
            }
          }
        ]
      },
      isShowFormatBANBox: false,
      bankAccountNameSpace: '',
      bankNameData: [],
      bankcardForm: {
        bankType: '',
        bankUserName: '',
        bankRegion: [],
        bankName: '',
        bankNameValue: '',
        bankBranchName: '',
        bankAccountId: '',
        bankAccountName: '',
        hasReadContract: false,
        bankSwift:'',//开户行行号
        bankUseTypeArr:[],
        bankUseType:""//账户类型
      }
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.GET_USER,
      bankcardList: types.GET_BANKCARD_LIST,
      cardTypeList: types.GET_CARD_TYPE_LIST,
      regionData: types.GET_REGION_DATA,
      bankUserName: types.GET_BANKCARD_LIST_NAME,
      selectedBankID: types.GET_SELECTED_BANK_ID_STATE,
      customerType: types.GET_BANKCARD_LIST_NAME_TYPE,
      selectedBankNO: types.GET_SELECTED_BANK_NO_STATE
    })
  },
  methods: {
    ...mapActions({
      setBankContract: types.SET_BANK_STATE,
      getBankcardList: types.SET_BANKCARD_LIST,
      getProvinceData: types.SET_PROVINCE_DATA,
      saveBankcardInfo: types.SAVE_BANKCARD_INFO,
      getCityAndDistrictData: types.SET_CITY_AND_DISTRICT_DATA,
      saveApplyLoanProgress: types.SAVE_APPLY_LOAN_PROGRESS,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setFailMessage: types.SET_FAIL_MESSAGE
    }),
    ...mapMutations({
      setSelectedBankcard: types.SELECT_BANKCARD,
      setSelectedBankID: types.SET_SELECTED_BANK_ID_STATE,
      setSelectedBankNO: types.SET_SELECTED_BANK_NO_STATE
    }),
    changeRegionData (val) {
      this.getCityAndDistrictData({val});
    },
    showBankContract () {
      this.setBankContract({
        show: true
      });
    },
    hideForm () {
      this.isaddBank = false;
      this.stepsTitle = '银行账户信息确认';
      this.bankcardForm = {
        bankType: '',
        bankUserName: '',
        bankRegion: [],
        bankName: '',
        bankNameValue: '',
        bankBranchName: '',
        bankAccountId: '',
        bankAccountName: '',
        hasReadContract: false,
        bankUseTypeArr:[],
        bankSwift:''
      };
      this.bankcardForm.bankAccountId = '';
      this.bankcardForm.bankNameValue = '';
    },
    saveBankcard () {
      for(let i = 0;i < this.bankcardForm.bankUseTypeArr.length; i++) {
            if(i == 0){
              this.bankcardForm.bankUseType = this.bankcardForm.bankUseTypeArr[i];
            }else{
              this.bankcardForm.bankUseType = this.bankcardForm.bankUseType+","+this.bankcardForm.bankUseTypeArr[i];
            }
      }
      const that = this;
      that.$refs.bankcardForm.validate((valid) => {
        if (valid) {
          that.isSubmitting = true;
          that.saveBankcardInfo({
            router: that.$router,
            token: that.userInfo.token,
            customerId: that.userInfo.crmCustomerId,
            bankType: 1,
            bankUserName: that.bankUserName,
            bankAccountName: `${that.bankcardForm.bankAccountName}`.replace(/\s/g, ''),
            bankName: that.selectedBank.bankNameValue,
            bankBranchName: that.bankcardForm.bankBranchName,
            bankAccountId: that.bankcardForm.bankAccountId,
            bankCounty: that.bankcardForm.bankRegion[2],
            bankProvince: that.bankcardForm.bankRegion[0],
            bankCity: that.bankcardForm.bankRegion[1],
            bankUseType: that.bankcardForm.bankUseType,
            bankSwift:that.bankcardForm.bankSwift
          }).then((res) => {
            const resData = res.data;
            that.isSubmitting = false;
            if (Number(resData.code) === 0) {
              that.getBankcardList({
                router: that.$router,
                token: that.userInfo.token
              });
              that.showList = true;
              that.$refs.bankcardForm.resetFields();
              that.bankcardForm.bankAccountId = '';
              that.bankcardForm.bankNameValue = '';
              that.bankNameData = [];
              that.stepsTitle = '银行账户信息确认';
              that.bankcardList_bl.bankList = [];
              that.goCrmBankAccountPage();
              that.isaddBank = false;
            }
          });
        } else {
          setTimeout(() => {
            placeholders.placeHolder(this);
          }, 30);
          return false;
        }
      });
    },
    closeCard () {
      this.showList = true;
      this.stepsTitle = '银行账户信息确认';
      this.bankcardForm = {
        bankType: '',
        bankUserName: '',
        bankRegion: [],
        bankName: '',
        bankNameValue: '',
        bankBranchName: '',
        bankAccountId: '',
        bankAccountName: '',
        hasReadContract: false
      };
    },
    changeBankName (val) {
      const selecteBank = _.find(this.bankNameData, item => item.value === val);
      // element ui 的坑，直接设置form的data会导致数据错乱，text和value搞不清，银行卡名称怎么保存都不对
      // v-model绑定的是value，但是点击修改设置了value之后就会把value当成text显示
      if (this.bankNameData.length && !_.isEmpty(val)) {
        this.selectedBank = {
          bankName: selecteBank.text,
          bankNameValue: selecteBank.value
        };
      }
    },
    showFormatBANBox () {
      this.bankAccountNameSpace = this.bankcardForm.bankAccountName;
      this.addBankcardNumSpaces();
      // this.isShowFormatBANBox = true;
    },
    addBankcardNumSpaces () {
      // 直接在input里面格式化有多个bug，暂无解决方案，主要是dom刷新问题
      const that = this;
      // vue 1里面可以给v-model上filter，2没有了这个特性，只能设法变通了
      const spaceRE = /(\s*)/g;  // 正则-所有空格
      const spaceEndRE = /(\s*$)/g;  // 正则-末位空格
      that.bankAccountNameSpace = that.bankcardForm.bankAccountName;
      that.bankAccountNameSpace = that.bankAccountNameSpace.replace(spaceRE, '').replace(/(\d{4})(?=\d)/g, '$1 ').replace(spaceEndRE, ''); // 替换末位空格
    },
    checkForm (bankcard) {
      // 因为element ui的限制，没有对应数据显示不出文本框里面对应层级的文字……
      this.getCityAndDistrictData({
        val: [bankcard.bankProvince]
      }).then(() => {
        this.getCityAndDistrictData({
          val: [bankcard.bankProvince, bankcard.bankCity]
        }).then(() => {
          this.showList = false;
          this.isaddBank = false;
          var bankUseTypeArr = [];
          if(bankcard.bankUseType){
            bankUseTypeArr = bankcard.bankUseType.split(",");
          }
          this.bankcardForm = {
            bankType: bankcard.bankType,
            bankUserName: bankcard.bankUserName,
            bankRegion: [
              bankcard.bankProvince,
              bankcard.bankCity,
              bankcard.bankCounty
            ],
            bankName: bankcard.bankName,
            bankNameValue: bankcard.bankNameValue,
            bankBranchName: bankcard.bankBranchName,
            bankAccountId: bankcard.bankAccountId,
            bankAccountName: bankcard.bankAccountName,
            bankSwift:bankcard.bankSwift,
            bankUseTypeArr:bankUseTypeArr
          };
          this.addBankcardNumSpaces();
        });
      });
    },
    newForm () {
      //this.bankcardForm.bankType = this.customerType == 1 ? '借记卡' : '企业账户';
      this.stepsTitle = '添加银行卡';
      this.isaddBank = true;
      this.$refs.bankcardForm.resetFields();
      this.bankcardForm.bankAccountId = '';
      this.bankcardForm.bankNameValue = '';
      this.bankcardForm.bankUserName = this.bankUserName;
      this.bankNameData = [];
      setTimeout(() => {
          placeholders.placeHolder(this);
      }, 30);
    },
    goBack () {
      this.$router.push({
        name: 'step2_bl',
        params: this.$route.params,
        query: this.$route.query
      });
    },
    goNext () {
      // 校验是否已经选中银行卡，不是的话警告，是的话保存并跳转
      /* this.selectedBankcard2 = _.find(
        this.bankcardList_bl.bankList,
        item => item.selected === true
      ); */
      this.selectedBankcard2 = [];
      for(let i=0;i<this.bankcardList_bl.bankList.length;i++){
        if(this.bankcardList_bl.bankList[i].selected == true){
          this.selectedBankcard2.push(this.bankcardList_bl.bankList[i]);
        }
      }
      if (this.selectedBankcard2.length<1) {
        this.setFailMessage({
          show: true,
          content: '请选择银行卡'
        });
      } else {
        this.fullscreenLoading = true; // loading遮罩层
        this.saveFrontBankAccount();
      }
    },
    addBankcardNumSpaces () {
      const spaceRE = /(\s*)/g; // 正则-所有空格
      const spaceEndRE = /(\s*$)/g; // 正则-末位空格
      this.bankcardForm.bankAccountName = this.bankcardForm.bankAccountName
        .replace(spaceRE, '')
        .replace(/(\d{4})(?=\d)/g, '$1 ')
        .replace(spaceEndRE, ''); // 替换末位空格
    },
    searchBankName (bankName) {
      api
        .getBankcardSelectData({
          router: this.$router,
          token: this.userInfo.token,
          bankName
        })
        .then((res) => {
          const resData = res.data;
          if (Number(resData.code) === 0) {
            this.bankNameData = resData.bankNameList;
          } else {
            this.bankNameData = [];
          }
        });
    },
    selectBankcard (bankcard) {

      this.selectedBankcard2 = [];
      for(let i=0;i<this.bankcardList_bl.bankList.length;i++){
        if(this.bankcardList_bl.bankList[i].selected == true){
          this.selectedBankcard2.push(this.bankcardList_bl.bankList[i]);
        }
      }

      this.bankcardList_bl.bankList.map((item, index) => {
          if (item.bankAccountId === bankcard.bankAccountId) {
            if(item.selected == true){
                item.selected = false;
              }else{
                if(this.selectedBankcard2.length < 2){
                  item.selected = true;
                }       
              }
          }
      });

      //强制渲染
      this.$forceUpdate();
    },

    //获取银行卡列表接口
    goCrmBankAccountPage () {
      const param = {
        token: localStorage.getItem('dl_tokenId_bl'),
        frontApplyId: this.$route.query.frontApplyId,
        type:'baoli'
      };
      api.getBankcardListData(param).then((res) => {
          if (res.data.code == '0') {
            this.bankcardList_bl2 = res.data.data.result;
            if (this.bankcardList_bl2.length > 0) {
              var selectedBankIdArr = [];
              if(res.data.data.selectedBankId && res.data.data.selectedBankId != ''){
                selectedBankIdArr = res.data.data.selectedBankId.split(",");
              }
              this.bankcardList_bl2.map((item, index) => {
                var selected = false;
                for(var i=0;i<selectedBankIdArr.length;i++){
                  if(item.bankAccountId == selectedBankIdArr[i]){
                    selected = true;
                  }
                }
                this.bankcardList_bl.bankList.push(
                  Object.assign(item, { selected: selected })
                );
              });
            }
          } else {
            this.setFailMessage({
              show: true,
              content: res.rspdesc || '数据获取失败'
            });
          }
        }).catch((error) => {
          this.setFailMessage({
            show: true,
            content: '网络异常，请稍后再试'
          });
        });
    },
    beforeCloseGylSuccessModal(){
      this.gylSuccessModal.show = false;
    },
    closeGylSuccessModal(){
      this.$router.push('/personalCenter/myLoan_bl/loanLists_bl');
    },
    //      绑定银行卡接口
    saveFrontBankAccount () {
      let bankAccountIdStr = "";
      for(let i=0;i<this.selectedBankcard2.length;i++){
        if(i == 0){
          bankAccountIdStr = this.selectedBankcard2[i].bankAccountId;
        }else{
          bankAccountIdStr = bankAccountIdStr+","+this.selectedBankcard2[i].bankAccountId;
        }
      }

      const param = {
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        frontApplyId: this.$route.query.frontApplyId,
        bankAccountId: bankAccountIdStr
      };
      applyloanApi
        .saveFrontBankAccount(param)
        .then((res) => {
          this.fullscreenLoading = false; // loading遮罩层
          if (res.rspcode === 1) {
            if (this.$route.query.yanse == 1) { // 供应链业务
              this.gylSuccessModal.show = true;
              this.gylSuccessModal.content = "结算意向已提交，请耐心等待买方确认付款信息。业务状态将在“我的保理”页面更新。";
            }
            //如果是非供应链业务跳转到第三步
            if(this.$route.query.yanse != 1){
              this.$router.push({
                path: `/applyLoan/${this.$route.params.id}/step3_bl`,
                query: {
                  frontApplyId: this.$route.query.frontApplyId,
                  selectedBankcardId: bankAccountIdStr,
                  yanse: this.$route.query.yanse,
                  productName: this.$route.query.productName
                }
              });
            }
          } else {
            this.setFailMessage({
              show: true,
              content: res.rspdesc || '数据获取失败'
            });
          }
        })
        .catch((error) => {
          this.fullscreenLoading = false; // loading遮罩层
          this.setFailMessage({
            show: true,
            content: '网络异常，请稍后再试'
          });
        });
    }
  },
  created () {
    this.$route.query.yanse;
  },
  mounted () {
    this.$store.commit('changeActive', 2);
    this.getBankcardList({
      token: this.userInfo.token,
      id: this.$route.query.frontApplyId,
      selectedBankcardId: this.$route.query.selectedBankcardId
    });
    this.getProvinceData();
    // 获取银行卡列表
    this.goCrmBankAccountPage();
  }
};
</script>
<style lang="scss">
@import "../../styles/bankcardList";

.step3-form .step-form__title {
  padding-bottom: 70px;
}
.step-form__btn-prev {
  background: #ff9f75;
  float: left;
  @include step-form__btn;
}
.step-form__btn-next {
  background: #eb662b;
  float: right;
  @include step-form__btn;
}
.step-form__btn-prev2 {
  background: #75bc42;
  float: left;
  @include step-form__btn;
}
.step-form__btn-next2 {
  background: #36a444;
  float: right;
  @include step-form__btn;
}
.bankcard-list__list——custom{
    color: #eb662b;
    padding-left: 130px;
    font-size: 13px;
    display: block;
    float: left;
    padding-top:15px;
    font-weight: bold;
}
.bankcard-list__list——jscustom{
    color: #eb662b;
    font-size: 13px;
    padding-left: 10px;
    padding-top:15px;
    display: block;
    float: left;
    font-weight: bold;
}
.bankcard-list__list——jscustom-single{
    color: #eb662b;
    font-size: 13px;
    padding-left: 200px;
    padding-top:15px;
    display: block;
    float: left;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// Step3_bak_bl.vue?49388966